import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@sportninja/common/config/queryKeys'
import { getGameRosters } from '@sportninja/common/services/game/rosterServices'

const useGameRosters = ({ gameId }) => {
  return useQuery({
    queryKey: queryKeys.gameRosters.byGame(gameId),
    queryFn: () => getGameRosters(gameId),
    enabled: Boolean(gameId),
  })
}

export default useGameRosters
